import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import RadioFieldSet from 'components/ui/RadioFieldSet';
import YesNoQuestionnaire from 'components/shared/YesNoQuestionnaire';
import { RadioButtonLegend } from '../AssistedPassengerSelection.styles';
import { questions } from '../AssistedPassengerSelection.constants';
import { noPassengers } from '../../../BookingMagnet.constants';

const defaultPassengerTypeOptions = [
  { value: 'adults', label: <FormattedMessage id="wheelchairSearch.passengerType.adult" /> },
  { value: 'youths', label: <FormattedMessage id="wheelchairSearch.passengerType.youth" /> },
  { value: 'children', label: <FormattedMessage id="wheelchairSearch.passengerType.child" /> },
  { value: 'seniors', label: <FormattedMessage id="wheelchairSearch.passengerType.senior" /> }
];

const splitSeniorsPassengerTypeOptions = [
  { value: 'adults', label: <FormattedMessage id="wheelchairSearch.passengerType.adult" /> },
  { value: 'youths', label: <FormattedMessage id="wheelchairSearch.passengerType.youth" /> },
  { value: 'children', label: <FormattedMessage id="wheelchairSearch.passengerType.child" /> },
  { value: 'seniors60To64', label: <FormattedMessage id="wheelchairSearch.passengerType.senior60To64" /> },
  { value: 'seniors65Plus', label: <FormattedMessage id="wheelchairSearch.passengerType.senior65Plus" /> }
];

const NonWheelchairPassengerSelection = ({ onChangePassengers, containSNCBDBOrNSStation }) => {
  const [passengerType, setPassengerType] = useState(null);
  const [yesNoAnswers, setYesNoAnswers] = useState(null);

  const updatePassengers = (paxType, answers) => {
    if (paxType && answers) {
      onChangePassengers({
        ...noPassengers,
        nonWheelchairCompanions: answers[questions.WITH_COMPANION] ? 1 : 0,
        guideDogs: answers[questions.WITH_GUIDE_DOG] ? 1 : 0,
        [paxType]: 1
      });
    }
  };

  const handlePassengerTypeChange = ({ target: { value } }) => {
    setPassengerType(value);
    updatePassengers(value, yesNoAnswers);
  };

  const handleAllYesNoAnswers = (answers) => {
    setYesNoAnswers(answers);
    updatePassengers(passengerType, answers);
  };

  const passengerTypeOptions = containSNCBDBOrNSStation ? splitSeniorsPassengerTypeOptions : defaultPassengerTypeOptions;

  return (
    <>
      <RadioFieldSet
        noDefault
        name="nonWheelchairPassengerType"
        legend={
          <RadioButtonLegend>
            <FormattedMessage id="wheelchairSearch.questions.passengerType" />
          </RadioButtonLegend>
        }
        radioButtons={passengerTypeOptions}
        selectedValue={passengerType}
        onChange={handlePassengerTypeChange}
      />
      <YesNoQuestionnaire
        onAllAnswersSelected={handleAllYesNoAnswers}
        questions={[
          {
            name: questions.WITH_COMPANION,
            legend: (
              <RadioButtonLegend>
                <FormattedMessage id="wheelchairSearch.questions.withCompanion" />
              </RadioButtonLegend>
            )
          },
          {
            name: questions.WITH_GUIDE_DOG,
            legend: (
              <RadioButtonLegend>
                <FormattedMessage id="wheelchairSearch.questions.withGuideDog" />
              </RadioButtonLegend>
            )
          }
        ]}
      />
    </>
  );
};

NonWheelchairPassengerSelection.propTypes = {
  onChangePassengers: PropTypes.func.isRequired,
  containSNCBDBOrNSStation: PropTypes.bool
};

export default NonWheelchairPassengerSelection;
